// Max content width for the RecoveryAI content column, per the Figma layout.
// ONE literal for the wizard step bodies AND the Settings panes so the two
// surfaces can't drift on independent magic numbers (AI-160 review).
// Wizard/constants.ts re-exports this as WIZARD_CONTENT_MAX_WIDTH so its
// existing importers are untouched.
export const RECOVERY_AI_CONTENT_MAX_WIDTH = '1108px'

// z-index for the wizard's sticky header (top) and playback (bottom) bars
// (AI-1123). Above in-page content and dropdowns (which top out at 10) so the
// bars sit over the scrolling step body, but below the tour scrim (998) so the
// coach-mark still dims and cuts out the Continue button it anchors to.
export const WIZARD_STICKY_BAR_Z_INDEX = 100

// Height of the app's global top navbar — a fixed (`position: fixed`) bar at
// `top: 0`, `z-index: 900`. This is a MIRRORED literal of the SCSS
// `$navbar-height`, declared in `src/index.scss` and re-declared — the copy
// actually consumed, last-writer-wins after index.scss's `@import` — in
// `src/stylesheets/variables/_bootstrap.scss`; `LiveUpdates/useCollapsingHeader.ts`
// holds a further copy. Keep all of them at the same value. The wizard's sticky
// header (AI-1123) pins at this offset so it lands directly BELOW the app navbar
// instead of behind it. (A `:root { --navbar-height }` CSS var would collapse
// these to one source, but `var()` reads back as `''` from jsdom's
// getComputedStyle, so the sticky-offset test could no longer assert the value —
// kept as a literal so that test can guard it.)
export const APP_NAVBAR_HEIGHT = '3.125rem'
